import type Highcharts from "highcharts";
import React from "react";
import { color } from "../..";
import { zIndexChart } from "../BetterHighcharts";

const PLOTLBAND_ID = "nodata-plotband";

const getPattern = (navigator: boolean) => ({
  pattern: {
    path: {
      d: "M -1,2 l 6,0",
      strokeWidth: navigator ? 1.2 : 1.7,
      stroke: color.titanium100,
    },
    width: 4,
    height: 4,
    color: color.hydrogen,
    patternTransform: navigator ? "scale(1.2) rotate(130)" : "scale(2) rotate(130)",
  } as unknown as Highcharts.PatternOptionsObject,
});

const useNoDataPlotBands = ({
  chartRef,
  intervals,
}: {
  chartRef: React.RefObject<Highcharts.Chart>;
  intervals: { from: number; to: number }[];
}) => {
  React.useLayoutEffect(() => {
    const chart = chartRef.current;
    if (!chart) {
      throw new Error("chart not found");
    }
    const xAxis = chart.xAxis[0];
    const xAxisNavigator = chart.xAxis[1];
    if (xAxis === undefined || xAxisNavigator === undefined) throw new Error("Missing xAxis");
    xAxis.removePlotBand(PLOTLBAND_ID);
    xAxisNavigator.removePlotBand(PLOTLBAND_ID);
    for (const { from, to } of intervals) {
      xAxis.addPlotBand({
        from,
        to,
        id: PLOTLBAND_ID,
        zIndex: zIndexChart.plotBands,
        color: getPattern(false),
      });
      xAxisNavigator.addPlotBand({
        from,
        to,
        id: PLOTLBAND_ID,
        zIndex: zIndexChart.plotBands,
        color: getPattern(true),
      });
    }
  }, [intervals, chartRef]);
};

export default useNoDataPlotBands;
